{
  "id": "oryza",
  "name": "Gramene Oryza",
  "version": "v4",
  "url": "https://oryza.gramene.org",
  "ensemblURL": "https://oryza-ensembl.gramene.org",
  "ensemblSite": "https://oryza-ensembl.gramene.org/genome_browser/index.html",
  "ensemblRest": "https://data.gramene.org/pansite-ensembl",
  "grameneData": "https://data.gramene.org/oryza_v4",
  "curation": {
    "url": "http://curate.gramene.org/oryza_v4?since=4479&gene=",
    "taxa": {
      "39947": "Oryza sativa Japonica",
      "1736659": "Oryza sativa aus cA1 var. N22",
      "39946000": "Oryza sativa indica 93-11",
      "39947002": "Oryza sativa indica cB var. Os117425",
      "39947003": "Oryza sativa indica XI-2B var. Os125619",
      "39947004": "Oryza sativa indica XI-3B2 var. Os125827",
      "39947005": "Oryza sativa indica XI-3B1 var. Os127518",
      "39947006": "Oryza sativa indica XI-3A var. Os127564",
      "39947007": "Oryza sativa aus cA2 var. Os127652",
      "39947008": "Oryza sativa indica XI-1B2 var. Os127742",
      "39947009": "Oryza sativa japonica GJ-trop2 var. Os128077",
      "39947010": "Oryza sativa japonica GJ-subtrp var. Os132278",
      "39947011": "Oryza sativa indica XI-2A var. Os132424",
      "39947001": "Oryza sativa japonica GJ-trop1 var. Azucena",
      "39947012": "Oryza sativa indica XI-1B1 var. IR64",
      "399470014": "Oryza sativa indica XI-adm var MH63",
      "399470015": "Oryza sativa indica XI-1A var ZS97"
    }
  },
  "targetTaxonId": 3702,
  "portals": ['browser','blast'],
  "portals2": ['browser','reactome','climtools','blast','atlas','trackhub'],
  "showInMenu": true,
  "showNews": true,
  "showGuides": true,
  "showFeed": true,
  "showTweets": true,
  "date": "2022-03-30"

}
